"use client";

// ── Interview Prep (EX-FNC07): the list read and its hook ──────────────────
// Softly authenticated like the library: `fetcher` attaches the bearer when
// `AuthProvider` has one, and only then does the answer carry the reader's
// own state. The key carries the viewer for the same reason the library's
// does (`features/judge/hooks.ts`): one URL, two answers.

import { useQuery } from "@tanstack/react-query";
import { fetcher } from "@/lib/api";
import { INTERVIEW_TOPICS, type InterviewPrepList } from "./types";

export async function fetchInterviewPrep(): Promise<InterviewPrepList> {
  const res = await fetcher<Partial<InterviewPrepList>>("/v1/judge/interview");
  if (!res.success) throw new Error(res.error.message);
  const data = res.data;
  return {
    topics: Array.isArray(data.topics)
      ? data.topics
      : INTERVIEW_TOPICS.map((key) => ({ key, total: 0, solved: null })),
    problems: Array.isArray(data.problems) ? data.problems : [],
    total: data.total ?? 0,
    viewer: data.viewer ?? null,
  };
}

export const interviewKeys = {
  list: (viewer: string) => ["judge", "interview", viewer] as const,
};

export function useInterviewPrep(viewerKey: string, enabled: boolean) {
  return useQuery({
    queryKey: interviewKeys.list(viewerKey),
    queryFn: fetchInterviewPrep,
    enabled,
    staleTime: 30_000,
    retry: false,
  });
}
